import React from 'react';
import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { useAccessControl } from '../../access-control/AccessControlContext';
import './TenantPrefsGear.css';

interface TenantPrefsGearProps {
  size?: number;
  className?: string;
}

/**
 * Gear icon linking to /tenant-preferences, rendered only for users allowed to
 * view that page (mirrors the PageGuard predicate, so it never dead-ends to
 * /unauthorized). Renders nothing while access-control config is still loading
 * or for unauthorized users.
 */
const TenantPrefsGear: React.FC<TenantPrefsGearProps> = ({ size = 20, className }) => {
  const { loaded, canViewPage } = useAccessControl();

  if (!loaded || !canViewPage('tenant-preferences', true)) return null;

  return (
    <Link
      to="/tenant-preferences"
      className={`tenant-prefs-gear${className ? ` ${className}` : ''}`}
      title="Tenant Preferences"
      aria-label="Tenant Preferences"
      // The home-page avatar pill navigates to /profile on click; keep the gear
      // from bubbling into that handler.
      onClick={(e) => e.stopPropagation()}
    >
      <Settings size={size} />
    </Link>
  );
};

export default TenantPrefsGear;
